function initIvelloraCollectionCopy(root = document) {
  root.querySelectorAll('[data-ivellora-collection-copy]').forEach((copy) => {
    const section = copy.closest('.yuanqi-collection-seo');
    const toggle = section?.querySelector('[data-ivellora-collection-copy-toggle]');
    if (!toggle) return;

    if (!copy.classList.contains('is-expanded')) {
      toggle.hidden = copy.scrollHeight <= copy.clientHeight + 2;
    }

    if (toggle.dataset.ivelloraBound === 'true') return;
    toggle.dataset.ivelloraBound = 'true';
    toggle.addEventListener('click', () => {
      const expanded = copy.classList.toggle('is-expanded');
      toggle.setAttribute('aria-expanded', String(expanded));
      toggle.textContent = expanded ? 'Show less' : 'Read more';
    });
  });
}

document.addEventListener('DOMContentLoaded', () => initIvelloraCollectionCopy());
document.addEventListener('shopify:section:load', (event) => initIvelloraCollectionCopy(event.target));
window.addEventListener('resize', () => initIvelloraCollectionCopy());
